module.exports = __webpack_public_path__ + "static/media/Right Hip Cartoon.5daa38f7.png";